<template>
  <vs-card>
    <div slot="header">
      <h3>Produtos</h3>
    </div>
    <table class="table table-bordered">
      <tr>
        <th>Nome Produto</th>
        <th class="hidden sm:block">Tipo</th>
        <th class="hidden sm:block">Valor Inicial</th>
        <th>Valor Desconto</th>
        <th>Valor Final</th>
        <th class="hidden sm:block">Forma de Pagamento</th>
      </tr>
      <tr v-for="item in listProdutos" :key="item.idProduto">
        <td>
          {{ item.nomeProduto }}
        </td>
        <td class="hidden sm:block">
          {{ item.obrigatorio ? 'Obrigatório' : 'Opcional' }} -
          {{ item.isMensal ? 'Mensal' : 'Entrada' }}
        </td>
        <td class="hidden sm:block">
          <span
            v-if="item.valor != item.valorFinal"
            style="text-decoration: line-through"
          >
            {{ item.valor | currency }}
          </span>
          <span v-else>
            {{ item.valor | currency }}
          </span>
        </td>
        <td>
          {{ (item.valor - item.valorFinal) | currency }}
        </td>
        <td>
          <b>{{ item.valorFinal | currency }}</b>
        </td>
        <td class="hidden sm:block">
          {{ item.nomePagamento }}
        </td>
      </tr>
    </table>
  </vs-card>
</template>

<script>
export default {
  props: ['listProdutos'],
};
</script>
